export default {
  allMsg: 'Tous les messages',
  systemMsg: 'Messages système',
  personMsg: 'Messages manuels',
  unread: 'Non lu',
  seeDetail: 'Voir les détails',
  read: 'Lu',
  replyNow: 'Répondre maintenant',
  message: 'Message',
  operateSuccess: 'Opération réussie',
  holder: {
    searchHolder: "N° de colis/N° de commande/N° d'article",
  },
  addAcBuy: 'Rejoignez AcBuy Discord et gagnez 2000 ¥ en CASH !',
  flatActivity: '🎄 Offres Incontournables de Noël',
  joinNow1: 'Acheter Maintenant',
  tips1: '🎁 Profitez de Réductions Jusqu’à 80 %',
  tips2: '🎅 Offres de Fêtes en Édition Limitée!',
}
